import React from 'react';
import type { Player, PlayerOptions } from 'video.js';
import videojs from 'video.js';

export const useVideoJs = (options: PlayerOptions) => {
    const videoContainerRef = React.useRef<HTMLDivElement>(null);
    const [player, setPlayer] = React.useState<Player | null>(null);

    React.useEffect(() => {
        if (!videoContainerRef.current) return;

        videoContainerRef.current.innerHTML = '';
        const videoElement = document.createElement('video-js');
        videoElement.classList.add('customPlayerTheme');
        videoContainerRef.current.appendChild(videoElement);

        const vjsPlayer = videojs(videoElement, options);
        setPlayer(vjsPlayer);
        return () => {
            if (vjsPlayer) {
                vjsPlayer.dispose();
                setPlayer(null);
            }
        };
    }, [options]);

    return { videoContainerRef, player };
};
